import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import * as SecureLS from "secure-ls";
import Swal from "sweetalert2";

// Configuración de SweetAlert fuera del render para no recrearla
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export const useAuth = () => {
  const history = useHistory();
  const server = window.$linkserver;

  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  
  // Cambiamos a booleanos para un manejo más limpio en React
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [imagenBackground, setImagenBackground] = useState("");
  const [logo, setLogo] = useState("");

  useEffect(() => {
    document.documentElement.style.setProperty("--tipoS", "hidden");
    
    const getDataDominio = async (dominio) => {
      try {
        const response = await axios.get(`${server}empresas/getParametrosEmpresaDominio/${dominio}`);
        response.data.forEach((item) => {
          if (item.pae_tipo === 1) setImagenBackground(item.pae_parametro);
          if (item.pae_tipo === 3) setLogo(item.pae_parametro);
          if (item.pae_tipo === 4) {
            document.documentElement.style.setProperty("--primary", `#${item.pae_parametro}`);
          }
        });
      } catch (error) {
        console.error("Error obteniendo parámetros del dominio", error);
      }
    };

    const url = window.location.hostname;
    const sub = url.split(".");
    getDataDominio(sub[0]);
  }, [server]);

  const showMessage = (msn, type) => {
    Toast.fire({ title: msn, icon: type, confirmButtonText: "Entendido" });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const ls = new SecureLS({
      encodingType: "des",
      isCompression: false,
      encryptionSecret: "admin-hyundai",
    });

    setIsLoading(true);

    try {
      const response = await axios.get(`${server}usuario/logeoUser/${usuario}/${password}`);
      setIsLoading(false);

      if (response.status === 200) {
        showMessage("Logeo exitoso", "success");
        const infoUsuario = response.data;
        ls.set("ask-hy", { infoUsuario });
        history.push("/dashboard");
      } else {
        showMessage(response.data.message, "error");
      }
    } catch (error) {
      setIsLoading(false);
      showMessage("Ocurrió un error, inténtalo de nuevo", "error");
    }
  };

  return {
    usuario, setUsuario,
    password, setPassword,
    email, setEmail,
    isLoading,
    showModal, setShowModal,
    imagenBackground,
    logo,
    handleLogin
  };
};